// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"27d26714","453":"78006605","629":"0ae5bde5","973":"e1570ede"}[chunkId] + ".chunk.js";
};